<!--
 * @Author: Jarun
 * @Date: 2021-03-25 16:06:51
 * @LastEditTime: 2021-04-16 10:35:18
 * @LastEditors: Please set LastEditors
 * @Description: LoginHeader
 * @FilePath: \box.mengw.com\src\components\LoginHeader\LoginHeader.vue
-->
<template>
    <div class="login_header_components">
        <NavBar :border="false" fixed placeholder @click-left="onLeft" @click-right="onRgiht">
            <template #left>
                <div class="icon_back"></div>
            </template>
            <!-- <template #title>
                <div class="icon_logo" :style="{ backgroundImage: `url(${iconLogo})` }"></div>
            </template> -->
            <template #right>
                <div class="icon_kefu"></div>
            </template>
        </NavBar>
    </div>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs, onMounted, } from 'vue';
import { NavBar } from 'vant';
import './LoginHeader.less';
import router from '@/router';
// import iconLogo from '@/assets/images/common/logo.png';

import Util from "@/assets/js/lib/util";

export default defineComponent({
  name: 'LoginHeader',
  components: {
    NavBar,
  },
  props: {
  },
  setup() {

    const state = reactive({
        util: new Util(),
        // iconLogo,
    })

    const onLeft = () => {
      router.back();
    };

    const onRgiht = () => {
      state.util.complaint();
    };

    return {
      onLeft,
      onRgiht,
      ...toRefs(state)
    };
  },
});
</script>
